import { render, staticRenderFns } from "./IndependentStatistician.vue?vue&type=template&id=0ee08306&"
import script from "./IndependentStatistician.vue?vue&type=script&lang=js&"
export * from "./IndependentStatistician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports